/**
* author: duxin
* date: 2020/4/8
* describe:
*/

<template>
    <div>
        <Banner :bannerContent="bannerData"></Banner>
        <div class="content">
            <ElRow>
                <template v-for="item in bookList">
                    <ElCol :xs="{span:20,push:2}" :sm="{span:22,push:1}" :md="8" :lg="8" :xl="8" class="book-wrap">
                        <div class="book-item" :key="item.bookId">
                            <div class="cover">
                                <img :src="item.bookPicPOFirst.imageUrl" alt="图片">
                            </div>
                            <div class="book-content">
                                <p class="book-name" @click="onOpen(item.bookId)">{{item.bookName}}</p>
                                <p class="book-desc">{{item.description}}</p>
                                <p class="more" @click="onOpen(item.bookId)">MORE</p>
                            </div>
                        </div>
                    </ElCol>
                </template>
            </ElRow>
        </div>
    </div>
</template>

<script>
    import {GetBookList} from '../../api/web'
    import Banner from "./components/banner"

    export default {
        name: "books",
        components: {Banner},
        data() {
            return {
                bannerData: {
                    src: require('../../assets/news_banner.jpg'),
                    title:  this.$t("menu.book")
                },
                bookList: []
            }
        },
        methods: {
            init() {
                let _params = {
                    companyId: 1,
                    pageNum: 1,
                    pageSize: 10000
                };
                GetBookList(_params).then(res => {
                    if (res.status) {
                        this.bookList = res.data?.dataList || [];
                    }
                })
            },
            onOpen(bookId) {
                this.$router.push({name: "WEB", query: {bookId: bookId}})
            }
        },
        mounted() {
            this.init();
        }
    }
</script>

<style lang="less" scoped>
    @import "../../style/constant.less";

    .top-wrap {
        position: relative;

        .title {
            position: absolute;
            z-index: 10;
            top: 150px;
            right: 150px;
            font-size: 32px; 
            font-weight: 500;
            color: white;
            text-shadow: 2px 2px 5px #bdbdbd;
        }

        .bg {
            width: 100%;
            height: 700px;
        }
    }

    .content {
        max-width: @page-width;
        margin: 0 auto;
        padding-bottom: 80px;
        padding-top: 50px;

        .book-wrap {
            padding-top: 60px;

            &:nth-child(1) {
                padding-top: 30px;
            }

            &:nth-child(2) {
                padding-top: 30px;
            }

            &:nth-child(3) {
                padding-top: 30px;
            }
        }

        .book-item {
            max-width: 280px;
            margin: 0 auto;
            box-shadow: 2px 2px 5px #c3c3c3;
            background-color: white;

            .cover {
                height: 180px;
                text-align: center;
                border-bottom: 1px solid #d4d4d4;
                overflow: hidden;

                img {
                    width: 50%;
                    height: 100%;
                    object-fit: fill;
                }
            }

            .book-content {
                padding: 15px;


                .book-name {
                    font-size: 18px;
                    font-weight: bold;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;

                    &:hover {
                        cursor: pointer;
                        color: #e76c5e;
                    }
                }

                .book-desc {
                    margin-top: 10px;
                    min-height: 72px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                }

                .more {
                    color: #435ba1;
                    cursor: pointer;
                    text-align: right;
                    margin-top: 15px;

                    &:hover {
                        color: #e76c5e;
                    }
                }
            }
        }
    }


</style>
